<div class="switch-view-container">
  <ng-container *ngIf="(state | async).kyc.length; else noKYC">
    <div
      class="table-container uk-margin"
      [ngClass]="{
        'table-height-user': (state | async).investments.length && view === 'user',
        'table-height-investment-company': (state | async).investments.length && view === 'investmentCompany'
      }">
      <table class="uk-table uk-table-justify uk-table-divider uk-table-striped uk-table-hover uk-table-small uk-table-middle">
        <thead>
          <tr>
            <th class="uk-text-nowrap" i18n="@@CreatedDate">created date</th>

            <th class="uk-text-nowrap" i18n="@@question">question</th>

            <th class="uk-text-nowrap uk-text-right" i18n="@@answer">answer</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let kyc of kycArray">
            <td>{{ kyc.created_date | date: 'yyyy.MM.dd, HH:mm' }}</td>

            <td>
              <ng-container *ngIf="kyc.question.length <= 70; else questionModal">
                {{ kyc.question }}
              </ng-container>

              <ng-template #questionModal>
                <div appFullText [title]="'Question'" [text]="kyc.question" [modal]="modal" class="pointer">
                  {{ kyc.question.substr(0, 67) + '...' }}
                </div>
              </ng-template>
            </td>

            <td class="uk-text-right last-column-text">
              <ng-container *ngIf="kyc.answer_text; else noKYCAnswer">
                <ng-container *ngIf="!kyc.answers; else multiAnswersQuestion">
                  <ng-container *ngIf="kyc.answer_text.length <= 70; else longKYCAnswer">
                    {{ kyc.answer_text }}
                  </ng-container>

                  <ng-template #longKYCAnswer>
                    <div appFullText [title]="'Answer'" [text]="kyc.answer_text" [modal]="modal" class="pointer">
                      {{ kyc.answer_text.substr(0, 67) + '...' }}
                    </div>
                  </ng-template>
                </ng-container>

                <ng-template #multiAnswersQuestion>
                  {{ kyc.answers }}
                </ng-template>
              </ng-container>

              <ng-template #noKYCAnswer>
                <span uk-icon="minus"></span>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-template #noKYC>
    <div *ngIf="(state | async).alreadyRequested.includes(switchViews.KYC)" class="uk-text-center" i18n="@@KYCNotStarted">
      KYC has not been started.
    </div>
  </ng-template>
</div>
